import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { CommonService } from 'src/app/services/common.service';
import { OPTIONS, SSO_SYSTEMS } from 'src/app/classes/Enums';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [
        animate(1500, style({ opacity: 1 })),
      ]),
    ]),
  ],
})

export class HomeComponent extends BaseComponent implements OnInit {
  systemID: any;
  optionID: any;
  urls: any;
  constructor(private commonService: CommonService) {
    super();
    this.systemID = SSO_SYSTEMS;
    this.optionID = OPTIONS;
  }
  ngOnInit(): void {
    this.getUrlsForSystem().subscribe(urlObjects => {
      if (urlObjects.length > 0) {
        this.urls = urlObjects;
      }
    });
  }

  goToSystem(SystemxId: any) {
    let url: any;
    switch (SystemxId) {
      case SSO_SYSTEMS.IMLK_MANEGER:
        url = this.urls.filter(url => url.systemID === SSO_SYSTEMS.IMLK_MANEGER)[0].optionVal;
        break;
      case SSO_SYSTEMS.IMLK_VIEWER:
        url = this.urls.filter(url => url.systemID === SSO_SYSTEMS.IMLK_VIEWER)[0].optionVal;
        break;
      case SSO_SYSTEMS.WORKFLOW_ADMIN:
        url = this.urls.filter(url => url.systemID === SSO_SYSTEMS.WORKFLOW_ADMIN)[0].optionVal;
        break;
      case SSO_SYSTEMS.WORKFLOW_END_USER:
        url = this.urls.filter(url => url.systemID === SSO_SYSTEMS.WORKFLOW_END_USER)[0].optionVal;
        break;
      case SSO_SYSTEMS.DEWAN_ADMIN:
        url = this.urls.filter(url => url.systemID === SSO_SYSTEMS.DEWAN_ADMIN)[0].optionVal;
        break;
      case SSO_SYSTEMS.DEWAN_END_USER:
        url = this.urls.filter(url => url.systemID === SSO_SYSTEMS.DEWAN_END_USER)[0].optionVal;
        break;
      default:
        console.error('Invalid SystemxId:', SystemxId);
        break;
    }
    window.open(url + "?sso=" + this.user.Sso, '_blank');
  }

  getUrlsForSystem(): Observable<{ systemID: number, optionVal: string }[]> {
    let wrapper = {};
    wrapper["optionID"] = OPTIONS.URL;
    return this.commonService.getSettings(wrapper).pipe(
      map(data => data.map(item => ({ systemID: item.systemID, optionVal: item.optionVal })))
    );
  }
}
